// import {Component,ViewChild , ElementRef ,Renderer, ɵConsole} from '@angular/core';
// import {NavController,Content, Events, ToastController,ModalController,PopoverController,FabContainer} from 'ionic-angular';
// import { Headers , RequestOptions, Http } from '@angular/http';
// import  {LoginPage} from '../login/login';
// import { MsgManager } from '../../providers/msg-manager';
// import {Api} from "../../providers/api";
//
// import {ItemPage} from "../item-details/item-details";
// import {CartPage} from "../cart/cart";
// import {SearchPage} from "../search/search";
// import {SearchCustomersPage} from "../search-customers/search-customers";
// import {CustomerWishListPage} from "../customer-wish-list/customer-wish-list";
//
//
// import {ApiOffline} from "../../providers/api-offline";
// import {CartManager} from "../../providers/cart-manager";
// import {CART} from "../../providers/data";
//
// import { IMAGES_BASE_URL } from "../../providers/config";
// import { CATEGORIESnTAGS } from "../../providers/data";
// import {Constants,CollectionAndClasses,ApplicationVariables, LicenseName} from '../../providers/config';
// import { MyOrderPage } from '../my-order/my-order';
// import { BookmarksPage } from '../bookmarks/bookmarks';
// import {ItemsModalPage} from '../items-modal/items-modal';
// import 'rxjs/add/operator/map';
//
// import { Storage } from '@ionic/storage';
// import { SpinnerDialog } from 'ionic-native';
//
// import { WebstoreUserSelfEditPage } from '../webstore-user-self-edit/webstore-user-self-edit';
//
// import {GVLogger} from '../../services/gv-logger';
// import * as moment from 'moment';
// import { TokenManager } from '../../providers/token-manager';
//
// @Component({
//   selector: 'page-items',
//   templateUrl: 'items.html'
// })
// export class ItemsPage {
//   showInfiScroll = false;
//   public constants = Constants;
//   public collectionAndClasses = CollectionAndClasses;
//
//   imageNotFoundObject:any;
//
//   showSubCollections = false;
//   showBookmark = false;
//   allSelected = false;
//   showCollections = false;
//
//   allClasses:any;
//
//
//   attributeMenu:any = [];
//   selectedAttributes = [];
//
//   isLicenseName = false;
//   showClasses = false;
//   selectedSubCol = null;
//   selectedClass = null;
//
//   classesList:any = [];
//
//   selectedCollection:any;
//
//   isWebstore = 0;
//   singleValue4 = 0;
//
//   rightMarginOFbookMark = "{margin-top: -8px; font-size: 45px; position: absolute;top: 0;right: 310px;}";
//   breadCrumbs = "Browse Products for ";
//
//   @ViewChild(Content) content: Content;
//
//   baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
//   tagsSelected: any;
//
//   public itemsList = [];
//   public allDataLoaded = false;
//   public customerName = "";
//   tagsStatus:boolean = false;
//   scrollLock:boolean = false;
//   pageNo = 0;
//   buttonsStatus = true;
//   previousButtonStatus = true;
//   nextButtonStatus = true;
//   previousComplete = false;
//   nextComplete = false;
//
//   showNegative = false;
//
//   scrollEventCount:number = 0 ;
//
//   infiniteScrollGlobal:any;
//
//   public categories = [];
//
//   public collection = [];
//   public subCollection = [];
//
//   public itemCount = 0;
//
//   public currentIndex;
//   public arrayItemsCount = 0;
//
//   // category or tag/s info
//   public category: any = [];
//   public tags: any = []; // to take care of tags, we need to define the related tags class etc...
//
//   // view type
//   public viewType;
//
//   // sort by
//   public sortBy = 'Best Match';
//
//   allCatChip:boolean = false;
//
//   cacheImages = false;
//   cacheImagesTag = "cacheImages";
//   isOffline =false;
//
//   attributesPropertiesMap:any = new Map();
//
//   searchQuery = "";
//
//   adpCustomerInfo:any ={};
//
//   public cart : any;
//
//   constructor(public nav: NavController,
//    public api:Api, private cartManager:CartManager,
//    public events:Events,
//    public elementRef:ElementRef ,
//    public renderer:Renderer,
//    private storage:Storage,
//    private toastCtrl:ToastController,
//    private gVLogger:GVLogger,
//    private msgManager:MsgManager,
//    private modalCtrl:ModalController,
//    private popOver:PopoverController,
//    private fab:FabContainer,
//    private apiOffline:ApiOffline,
//    private tokenManager:TokenManager,
//    private http:Http,
//
//    ) {
//     this.cart = CART;
//     this.disablePreviousButton();
//     this.viewType = 'grid';
//
//     this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
//     this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();
//     this.isOffline = ApplicationVariables.isOffline;
//     // alert("offline check : " + ApplicationVariables.isOffline);
//
//
//
//     CollectionAndClasses.collection = [0];
//     CollectionAndClasses.subCollection=[0];
//     CollectionAndClasses.categories=[0];
//     CollectionAndClasses.tags=[0];
//     CollectionAndClasses.attributeFilter=[];
//
//    // this.gVLogger.log("constructor");
//    if(Constants.isWebstore){
//      this.isWebstore = 1
//    }
//
//    this.storage.get(this.cacheImagesTag).then((cache)=>{
//      this.cacheImages = cache;
//    });
//
//    this.storage.get("defaultLayout").then((defaultLayout)=>{
//      if(defaultLayout === undefined || defaultLayout === null)
//           this.viewType = 'grid';
//       else
//         this.viewType = defaultLayout;
//    });
//
//    this.storage.get("negativeInventory").then((negativeInventory)=>{
//      this.showNegative = negativeInventory;
//    });
//
//    this.events.subscribe('refreshItems', () => {
//      this.gVLogger.log("refresh items event called")
//
//       this.getProductsResolver(0,false); // isPulltoRefresh = false
//     });
//
//    this.gVLogger.log("called constructor: Items");
//
//     this.customerName = this.cartManager.getCustomerName();
//
//     this.getCategoriesResolver();
//
//
//     this.api.get("category/all").map(res => res.json())
//     .subscribe(data =>{
//
//     if(data.status == "401"){ // check for session out
//             this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
//
//         this.nav.setRoot(LoginPage);
//       }else{
//         for(let cat of data.data){
//           cat.isActive = false;
//           this.categories.push(cat);
//         }
//         //this.highlightSelected();
//
//       }
//     });
//
//     this.api.get("tags/all").map(res => res.json())
//     .subscribe(data =>{
//       this.gVLogger.log('-------item.ts called-----');
//       if(data.status == "401"){ // check for session out
//         this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
//
//         this.nav.setRoot(LoginPage);
//       }else{
//         this.tags = data.data;
//         if(data.data.length <= 0){
//           this.tagsStatus = false;
//         }else{
//           this.tagsStatus = true;
//         }
//         this.tagsSelected = CATEGORIESnTAGS.tags;
//         //this.gVLogger.log(this.categories);
//       }
//     });
//
//     this.events.subscribe('categoriesUpdated',()=>{
//       this.collection = JSON.parse(localStorage.getItem("collection-"+this.cartManager.getADPCustomerUUID()));
//       this.allClasses = JSON.parse(localStorage.getItem("allClasses-"+this.cartManager.getADPCustomerUUID()));
//     });
//
//    // this.getProducts(0,false); // isPulltoRefresh = false
//
//   }
//
//
//
//   getCategoriesResolver(){
//
//       if(ApplicationVariables.isOffline){
//         this.getOfflineCategories();
//       }else{
//         this.getCollectionMenu();
//       }
//   }
//
//   getOfflineCategories(){
//
//
//       this.apiOffline.getCategories()
//     .then(result => {
//             // alert("Categories offline" + JSON.stringify(result));
//             var json = JSON.parse(result.rows.item(0).json);
//
//             this.allClasses = json.data.classes;
//             //this.classesList = this.allClasses;
//
//             for(let col of json.data.collectionsDTO){
//               col.isActive = false;
//               this.collection.push(col);
//             }
//             if(this.collection.length > 0){
//                this.showCollections = true;
//              }else{
//                this.showCollections = false;
//              }
//
//              setTimeout(() => {
//                 this.content.resize();
//             }, 80);
//     });
//   }
//
//
//
//   ionViewWillLeave() {
//
//       this.events.unsubscribe('Items:Refreshed',null);
//     }
//
//    ionViewDidLoad(){
//
//      this.gVLogger.log("Items page: view did load");
//     // this.highlightSelected();
//
//      this.getProductsResolver(0,false);
//
//    }
//
//   // switch to list view
//   viewList() {
//     this.viewType = 'list';
//   }
//
//   // swith to grid view
//   viewGrid() {
//     this.viewType = 'grid';
//   }
//
//   // get discount percent
//   discountPercent(originPrice, salePrice) {
//     return Math.round((salePrice - originPrice) * 100 / originPrice)
//   }
//
//
//   // view a item
//   viewItem(item) {
//
//     this.api.get("product/" + item.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
//       if(data.status === "200"){
//         item.description = data.data.description;
//       }
//     })
//     this.nav.push(ItemPage, {item: item})
//   }
//
//    // go to search page
//   goToSearch() {
//     this.nav.push(SearchPage);
//   }
//
//   // view cart
//   goToCart() {
//     this.nav.push(CartPage);
//   }
//   goToSearchCustomers(){
//     this.nav.push(SearchCustomersPage);
//   }
//
//   goToCustomerWishList(){
// 	this.nav.push(CustomerWishListPage);
//   }
//
//
//   doInfinite(infiniteScroll){
//
//     let cartItems = this.cartManager.getItems();
//     let adpCustomer = this.cartManager.getAdpCustomerInfo();
//     let body = this.collectionAndClasses;
//     body.detachProductSearchFromFilter = adpCustomer.detachProductSearchFromFilter;
//     let headers = new Headers({
//       'Content-Type': 'application/json'
//     });
//     let options = new RequestOptions({
//       headers: headers
//     });
//     this.itemCount = this.itemsList.length;
//     this.api.post("/products/searchProductsByCollectionsClassesAndTags/"+this.itemCount+"/"+this.cartManager.getCustomerID()+"?isWebStore="+this.isWebstore,JSON.stringify(body),options)
//     .map(res=>res.json())
//     .subscribe(result=>{
//
//       // this.scrollToTop();
//     this.gVLogger.log("HTTP Response Data Recived");
//       if(result.status == "401"){ // check for session out
//         this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
//
//         this.nav.setRoot(LoginPage);
//       }
//       else
//       {
//         for(let item of result.data.productsDTOs){
//           this.gVLogger.log("all items from the serve" +  item);
//
//
//           //for ( let item of result.data.productsDTOs){
//             item.attributesList = [];
//             if(item.attributeSearch.indexOf('>') !== -1){
//               let tempAttributesList = item.attributeSearch.split('>');
//               for(let attribute of tempAttributesList){
//                 if(attribute!== "")
//                 item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
//               }
//             //}
//             item.attributesList.sort(function(a,b){return a.orderId-b.orderId});
//
//
//             if(LicenseName.indexOf(this.cartManager.getAdpCustomerInfo().licenseName) !== -1){
//               this.isLicenseName = true;
//               this.rightMarginOFbookMark = "{margin-top: -8px; font-size: 45px; position: absolute;top: 0;right: 410px;}";
//                 this.api.get("proxy/part/"+item.barCode)
//                 .map(res=>res.json())
//                 .subscribe((result)=>{
//                   item.stockLocations = result.data;
//                 },
//                 (err)=>{
//                   this.gVLogger.log(err);
//                 }
//               );
//             }
//             else{
//               item.stockLocations = false;
//             }
//
//           }
//
//
//         setTimeout(() => {
//           // alert("after waiting....");
//         for(let at of this.attributeMenu){
//           at.atValue = this.cartManager.getAttributeValue(at.attribute);
//           at.compiledAttributes = []
//           for(let atval of at.values){
//             let id = atval;
//             let val:any = {};
//             val.id = id
//             val.text = this.cartManager.getAttributeValue(at.attribute+":"+id);
//             this.gVLogger.log(val);
//             at.compiledAttributes.push(val)
//           }
//         }
//
//       }, 3000);
//           item.productImagesDTO = JSON.parse(JSON.stringify(item.productImagesDTO.sort(function(a, b){return a.id - b.id})));
//
//           for(let cItem of cartItems){
//             if(item.id== cItem.id){
//                item = cItem;
//
//              }
//           }
//
//           this.itemsList.push(item);
//
//         }
//         infiniteScroll.complete();
//         // this.itemsList = result.data.productsDTOs;
//          // resolve(this.populateproducts(result,isPulltoRefresh));
//       }
//
//     }, error =>{
//       this.gVLogger.log(error);
//       this.presentToast("Server Down",3000,"bottom");
//     });
//   }
//
//   loadMore(){ // Next button
//
//     this.gVLogger.log("loadMore called");
//     if(!this.nextComplete){
//        SpinnerDialog.show("Loading...");
//        this.buttonsStatus = false;
//        this.nextButtonStatus = false;
//       this.gVLogger.log("New Scroll event.");
//       let count = this.currentIndex + this.arrayItemsCount;
//       this.gVLogger.log("iiiiinnnnnndexxxx" + count);
//        var completed = this.getProductsResolver(count,false).then(()=>{ // isPulltoRefresh = false
//          SpinnerDialog.hide();
//          this.buttonsStatus = true;
//         //  this.nextButtonStatus = true;
//        this.gVLogger.log("loadMore");
//      });
//     }else{
//       this.nextButtonStatus = false;
//       this.presentToast("No more products to load.", 2000,"bottom");
//     }
//     this.disablePreviousButton();
//   }
//
//   doRefresh(refresher) { // pullToRefresh
//      this.buttonsStatus = false;
//      let startPoint = this.currentIndex - this.arrayItemsCount ;
//      if(this.nextComplete){
//        startPoint -= this.arrayItemsCount;
//        this.nextComplete = false;
//      }
//      if(startPoint >=0){
//       this.getProductsResolver(startPoint,true).then(()=>{ // isPulltoRefresh = false
//          refresher.complete();
//          this.buttonsStatus = true;
//          this.gVLogger.log("Pull to refressh completed");
//        });
//      }else{
//        refresher.complete();
//        this.buttonsStatus = true;
//      }
//      this.disablePreviousButton();
//   }
//
//
//   loadPrvious() { // load Previous
//     if(!this.previousComplete){
//      SpinnerDialog.show("Loading...");
//      this.buttonsStatus = false;
//      let startPoint = this.currentIndex - this.arrayItemsCount ;
//      if(this.nextComplete){
//        startPoint -= this.arrayItemsCount;
//        this.nextComplete = false;
//      }
//      if(startPoint >=0){
//       this.getProductsResolver(startPoint,true).then(()=>{ // isPulltoRefresh = false
//          SpinnerDialog.hide();
//          this.buttonsStatus = true;
//        });
//      }else{
//        this.buttonsStatus = true;
//         this.presentToast("No more products to load",2000,"bottom");
//      }
//    }else{
//      this.presentToast("No more products to load",2000,"bottom");
//    }
//
//   this.disablePreviousButton();
//   if(this.pageNo <= 2){
//     this.previousButtonStatus = false;
//   }
//   }
//
// arrayUnique(array) {
//     var a = array.concat();
//     for(var i=0; i<a.length; ++i) {
//         for(var j=i+1; j<a.length; ++j) {
//             if(a[i].id === a[j].id)
//                 a.splice(j--, 1);
//         }
//     }
//
//     return a;
// }
//
//
// addProductToCart(item){
//   this.cartManager.addProductToCart(item);
// }
//
// removeProductFromCart(product){
//   this.cartManager.removeOneNew(product);
// }
//
// updateProductInCart(product){
//
//   if(String(product.quantity) !=""){
//     if(String(product.quantity).match(/^\d+$/)){
//       this.cartManager.updateCartNew(product);
//     }else{
//       if (Number(product.minOrder) != 0) {
//         product.quantity = Number(product.minOrder);
//       } else {
//         product.quantity = 1;
//       }
//       this.cartManager.updateCartNew(product);
//     }
//   }else{
//
//       product.quantity = Number(product.minOrder);
//       this.cartManager.updateCartNew(product);
//   }
//
//   }
//
//   allProducts(id){
//     this.nextComplete = false;
//
//     // this.classesList = this.allClasses;
//     this.classesList = [];
//
//     this.highlightSelectedCollection(0);
//
//     // this.content.scrollToTop(0);
//     CollectionAndClasses.collection = [0];
//     CollectionAndClasses.subCollection=[0];
//     CollectionAndClasses.categories=[id];
//
//     this.itemsList = [];
//     this.collectionAndClasses = CollectionAndClasses;
//     this.getProductsResolver(0,false);
//      this.highlightSelected(0);
//
//     setTimeout(() => {
//                 this.content.resize();
//             }, 80);
//
//   }
//
//   classesSelect(selectedClass){
//     // this.highlightSelected(selectedClass.id);
//     this.nextComplete = false;
//     this.selectedClass = selectedClass;
//
//     // this.content.scrollToTop(0);
//     // CollectionAndClasses.collection = [0];
//     //CollectionAndClasses.subCollection=[0];
//     CollectionAndClasses.categories=[selectedClass.id];
//
//     this.itemsList = [];
//     this.collectionAndClasses = CollectionAndClasses;
//     this.getProductsResolver(0,false);
//   }
//
//
//   getProductsResolver(itemCount,isPulltoRefresh){
//
//     this.gVLogger.log("In Product resolver item COUNT : " + itemCount + " ISPULLTO REFRESH " + isPulltoRefresh);
//
//     this.currentIndex = itemCount;
//     return new Promise((resolve)=>{
//
//       if(itemCount <= 0 && !isPulltoRefresh){
//         this.gVLogger.log("If called in product resolver");
//         itemCount = 0;
//         this.pageNo = 0;
//       }
//
//     if(ApplicationVariables.isOffline){
//       resolve(this.getProductsOffline(itemCount,isPulltoRefresh));
//     }else{
//       resolve(this.getProducts(itemCount,isPulltoRefresh));
//     }
//     });
//   }
//
//   getProductsOffline(itemCount,isPulltoRefresh){
//     // alert("getProductsOffline called");
//
//     return new Promise((resolve)=>{
//
//
//
//     //  alert("Enter in get products offline" + itemCount);
//
//     this.apiOffline.getProductsOffline(CollectionAndClasses,itemCount,this.searchQuery).then(result => {
//       // alert("result after getting offline products " + result);
//       // alert("result after getting offline products stringify" + JSON.stringify(result));
//
//
//       if(result.rows.length < 24){
//         this.nextButtonStatus = false;
//       }
//       else{
//         this.nextButtonStatus = true;
//       }
//
//           let response :any = {
//             status: 200,
//             message: "Offline Mode",
//             data: {productsDTOs:[]}
//           }
//
//
//
//
//
//             //UD
//
//       this.apiOffline.getAttributes().then(res => {
//         let attributes = JSON.parse(res);
//       })
//                 let productsLazy:any = [];
//                 // alert("length of the offline products" + result.rows.length);
//                 for(var i=0; i<result.rows.length; i++)
//                 {
//                     var json = JSON.parse(result.rows.item(i).json);
//                     // alert("Json of products" + JSON.stringify(json));
//                     productsLazy.push(json);
//                 }
//
//                 response.data.productsDTOs = productsLazy;
//               // alert(JSON.stringify(response));
//               this.populateproducts(response, isPulltoRefresh);
//             })
//
//     });
//
//   }
//
//
//   getProducts(itemCount,isPulltoRefresh){
//
//     this.showInfiScroll = false;
//     return new Promise(resolve => {
//
//       let body :any= this.collectionAndClasses;
//       body.searchQuery = this.searchQuery;
//     let headers = new Headers({
//       'Content-Type': 'application/json'
//     });
//     let options = new RequestOptions({
//       headers: headers
//     });
//
//     this.currentIndex = itemCount;
//     this.gVLogger.log("HTTP Request Before Send");
//
//
//     setTimeout(() => {
//
//     this.api.post("/products/searchProductsByCollectionsClassesAndTags/"+itemCount+"/"+this.cartManager.getCustomerID()+"?isWebStore="+this.isWebstore,JSON.stringify(body),options)
//     // this.api.post("/products/searchProductsByCollectionsClassesAndTag/"+itemCount+"/"+this.cartManager.getCustomerID()+"?isWebStore="+this.isWebstore,JSON.stringify(body),options)
//     .map(res=>res.json())
//     .subscribe(result=>{
//       if(result.data.productsDTOs.length < 12){
//         this.nextButtonStatus = false;
//       }
//       else{
//         this.nextButtonStatus = true;
//       }
//       this.showInfiScroll = true;
//       if(this.attributesPropertiesMap.size === 0){
//         this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
//       }
//
//       for ( let item of result.data.productsDTOs){
//
//         item.attributesList = [];
//
//         // if(item.attributeSearch.indexOf('>') !== -1){
//           if(item.attributeSearch !== -1 && item.attributeSearch != undefined){
//           let tempAttributesList = item.attributeSearch.split('>');
//           for(let attribute of tempAttributesList){
//             if(attribute !== "")
//             item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
//           }
//         }
//
//
//         item.attributesList.sort(function(a,b){return a.orderId-b.orderId})
//         // result.data.attributeMenu = item.attributesList;
//       }
//
//       // this.scrollToTop();
//       if(result.status == "401"){ // check for session out
//         this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
//
//         this.nav.setRoot(LoginPage);
//       }else{
//          resolve(this.populateproducts(result,isPulltoRefresh));
//       }
//
//     }, error =>{
//       this.gVLogger.log(error);
//       this.presentToast("Server Down",3000,"bottom");
//     });
//   },0);
//   });
//   }
//
//
//   populateproducts(result,isPulltoRefresh){
//
//     return new Promise((resolve)=>{
//
//       //UD
//       if(!this.isOffline){
//         this.attributeMenu = result.data.attributeMenu;///////UD do this only for testing purpose
//
//
//         setTimeout(() => {
//
//           for(let at of this.attributeMenu){
//             at.atValue = this.cartManager.getAttributeValue(at.attribute);
//             at.compiledAttributes = [];
//             this.gVLogger.log("at.atvalue"+ at.atValue);
//
//             at.props = this.attributesPropertiesMap.get(at.attribute);
//             at.showStatus = at.props.attSearchStatus;
//             at.activeStatus = at.props.attActiveStatus;
//             for(let atval of at.values){
//               let id = atval;
//               let val:any = {};
//               val.id = id
//               val.text = this.cartManager.getAttributeValue(at.attribute+":"+id);
//               this.gVLogger.log(val);
//               at.compiledAttributes.push(val)
//             }
//
//             // at.compiledAttributes.sort(function(a){return a.text});
//             at.compiledAttributes.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
//
//           }
//           this.attributeMenu.sort(function(a, b){return a.props.attSequence-b.props.attSequence})
//
//           this.gVLogger.log("HERE"+this.attributeMenu);
//           let attributeMenu1 = [];
//
//           for(let attributes of this.attributeMenu){
//             if(attributes.activeStatus == 1){
//               attributeMenu1.push( attributes);
//             }
//           }
//
//           this.attributeMenu = attributeMenu1;
//           this.gVLogger.log("Without"+ this.attributeMenu)
//
//         }, 0);
//
//         for(let selections of this.selectedAttributes){
//           this.attributeMenu = this.attributeMenu.filter((o)=> {
//             return o.attribute !== selections.split(":")[0];
//           })
//         }
//
//       }
//
//
//
//       //UD
//
//     let cartItems = this.cartManager.getItems();
//
//     let oldItems = this.itemsList;
//
//           let pullTemp = [];
//
//           if(!(typeof result === 'undefined') && result){
//             if (result.data.productsDTOs && result.data.productsDTOs.constructor === Array) {
//
//             } else {
//               result.data.productsDTOs = [];
//             }
//           }else{
//             result = { data: {}};
//             result.data.productsDTOs = [];
//           }
//
//
//           if(result.data.productsDTOs.length >= this.arrayItemsCount || this.arrayItemsCount == 0){
//             this.arrayItemsCount = result.data.productsDTOs.length;
//           }
//
//           if(result.data.productsDTOs.length > 0){
//             this.itemsList = [];
//
//             if(isPulltoRefresh){
//               this.pageNo -= 1;
//               this.nextComplete = false;
//             }else{
//               this.pageNo += 1;
//               this.previousComplete = false;
//             }
//
//           }else{
//
//             if(isPulltoRefresh){
//               this.previousButtonStatus = false; //UD
//               this.previousComplete = true;
//             }else{
//               this.nextComplete = true;
//             }
//
//             this.presentToast("No more products to display.",3000,"bottom");
//
//           }
//
//
//         for ( let item of result.data.productsDTOs){
//
//           if(LicenseName.indexOf(this.cartManager.getAdpCustomerInfo().licenseName) !== -1){
//             this.isLicenseName = true;
//             this.rightMarginOFbookMark = "{margin-top: -8px; font-size: 45px; position: absolute;top: 0;right: 410px;}";
//           this.api.get("proxy/part/"+item.barCode)
//           .map(res=>res.json())
//           .subscribe((result)=>{
//             item.stockLocations = result.data;
//             this.gVLogger.log("InstantRead --- "+ item);
//
//           },
//           (err)=>{
//             this.gVLogger.log(err);
//           }
//           );
//
//         }
//         else{
//           item.stockLocations = false;
//         }
//
//
//         this.gVLogger.log("2 - "+ item.stockLocations);
//
//           item.productImagesDTO = JSON.parse(JSON.stringify(item.productImagesDTO.sort(function(a, b){return a.id - b.id})));
//           if(!Constants.isWebstore){
//             item.namecompact = item.name.length > 35 ? item.name.substring(0, 35 - 3) + "..." : item.name;
//             item.namecompact = item.name.length < 20  ? item.name + " . . . . ." : item.name;
//           }
//
//           item.quantity = 0 ;
//
//           for(let cartItem of cartItems){
//              if(item.id== cartItem.id){
//                item = cartItem
//              }
//
//           }
//           if(result.data.productsDTOs.length > 0){
//
//             if(isPulltoRefresh){
//               this.itemsList.push(item);
//               // if (item.productType === 0 ){
//               //   this.gVLogger.log("iiiiiiiiiffffffffff ccccccccallllllled");
//               //   this.itemsList.push(item);
//               // }else if(item.productType === 1 && item.qtyONHAND > 0){
//               //   this.itemsList.push(item);
//               // }
//
//             }else{
//               this.itemsList.push(item);
//
//             }
//           }
//         }
//
//
//
//         // alert("Item Count: "+ this.itemsList.length);
//
//
//         this.gVLogger.log("Old Itmes check ===>");
//         if(result.data.productsDTOs.length > 0){
//           if(oldItems.length > (this.arrayItemsCount * 1)){
//             this.gVLogger.log("old items length : "+oldItems.length +": current : "+this.arrayItemsCount);
//             if(isPulltoRefresh){
//                // arraysize = 2
//               // [1,2,3,4,5,6]
//               // [1,2]
//
//             this.itemsList = this.itemsList.slice(0,this.arrayItemsCount);
//
//             }else{
//               this.gVLogger.log("getting last items");
//               this.itemsList = this.itemsList.slice(Math.max(this.itemsList.length - this.arrayItemsCount, 1));
//
//             }
//
//           }
//         }
//
//             if(this.content != null){
//             //  this.content.scrollToTop(0).then(()=>{
//               setTimeout(()=>{
//                 resolve(true);
//               },300);
//             //});
//           }else{
//             resolve(true);
//           }
//
//        });
//
//   }
//
//
//
//   tagsSelectedChange(e){
//
//     CATEGORIESnTAGS.tags = this.tagsSelected;
//     if(CATEGORIESnTAGS.tags.length == 0){
//       CATEGORIESnTAGS.tags = [0];
//     }
//     this.getProductsResolver(0,false); // isPulltoRefresh = false
//
//   }
//
//   imageNotFound(e,item){
//    item.productImagesDTO[0].name = "dummy";
//    item.productImagesDTO[0].extension = "png";
//   }
//
//   getFallBackImage(dim){
//     if(this.constants.isWebstore){
//     return this.cartManager.makeNANImageURLFromImage(dim);
//
//     }else{
//       return "./assets/img/dummy-"+dim+".png";
//     }
//   }
//
//
//   scrollTop(){
//
//     this.nav.setRoot(ItemsPage);
//   }
//
//   discountCheck(discountPrice){ // if discount price is > 0, return true
//     if(Number(discountPrice) > 0){
//       return true;
//     }else{
//       return false;
//     }
//   }
//
//
//   highlightSelected(id){
//
//     for(let localCat of this.classesList){
//       if(id == localCat.id){
//         localCat.isSelected=true;
//       }else{
//         localCat.isSelected=false;
//       }
//     }
//
//   }
//
//
//   highlightSelectedSubCollection(sub,col){
//
//     this.highlightSelected(0);
//
//     for(let c of this.collection){
//       if(c.id == col.id){
//         for(let s of c.subCollection){
//           if(s.id == sub.id){
//              s.isSelected = true;
//           }else{
//              s.isSelected = false;
//           }
//         }
//       }
//     }
//
//   }
//
//   highlightSelectedCollection(col){
//     this.gVLogger.log("Collection Recived"+col);
//     this.gVLogger.log("Collection List"+this.collection);
//     this.highlightSelected(0);
//
//     if(col == 0){
//       this.allSelected = true;
//       for(let c of this.collection){
//              c.collection.isSelected = false;
//       }
//     }else{
//       this.allSelected = false;
//       for(let c of this.collection){
//       if(c.collection.id == col){
//          c.collection.isSelected = true;
//           }else{
//              c.collection.isSelected = false;
//           }
//       }
//
//     }
//
//   }
//
//   decimalLengthFixed(num,max){
//     return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
//   }
//
//
//    public identify(index, item) {
//     this.gVLogger.log("Item Name Is : "+item.name+" : ID : "+ item.id);
//     return item.id;
//   }
//
//
//
//   gotoOrdersPage(){
//     this.nav.setRoot(MyOrderPage);
//   }
//
//
//   presentToast(msg,duration,location) {
//     this.gVLogger.log("TOAST: "+msg);
//     let toast = this.toastCtrl.create({
//       message: msg,
//       duration: duration,
//       position: location
//     });
//     toast.present();
//   }
//
//   logOut(){
//     this.nav.setRoot(LoginPage);
//   }
//
//   showModalCollections(){
//     this.gVLogger.log("clicked modal call");
//     let mod = this.modalCtrl.create(ItemsModalPage);
//     mod.present();
//   }
//
//   allClick(){
//     CollectionAndClasses.attributeFilter = [];
//     this.collectionAndClasses.selectedAttributes = [];
//     this.selectedAttributes = [];
//     this.selectedSubCol = null;
//     this.selectedClass = null;
//     this.allProducts(0);
//   }
//
//
// collectionSelected(ev,col){
//   // alert("this.collection called");
//  this.gVLogger.log(col);
//
//  this.searchQuery = "";
//  this.selectedAttributes = [];
//  this.collectionAndClasses.attributeFilter = [];
//  this.selectedSubCol = null;
//  this.selectedClass = null;
//
//  if(col.subCollection.length > 0){
//    this.gVLogger.log("Have children");
//
//
//
//   this.nextComplete = false;
//   this.itemsList = [];
//   CollectionAndClasses.collection = [0];
//   this.toggleCollectionSubCollection();
//   this.selectedCollection = col;
//
//   let subcollections = [];
//   for ( let sub of this.selectedCollection.subCollection){
//     subcollections.push(sub.id);
//   }
//
//   if(subcollections.length < 1){
//     subcollections = [0];
//     CollectionAndClasses.collection = [col.collection.id];
//   }
//
//   this.classesList = [];
//   // this.classesList = this.selectedCollection.collection.classes;
//   if(col.subCollection.length > 0){
//
//     this.subCollection = col.subCollection;
//   }else{
//     this.subCollection = [];
//   }
//
//     CollectionAndClasses.subCollection = subcollections;
//     CollectionAndClasses.categories=[0];
//     CollectionAndClasses.tags=[0];
//
//
//     this.collectionAndClasses = CollectionAndClasses;
//     this.getProductsResolver(0,false);
//
//    // this.getProductsOffline(0,false);
//
//     setTimeout(() => {
//             this.content.resize();
//         }, 80);
//
//     }else{
//    this.toggleCollectionSubCollection();
//
//       this.gVLogger.log("No children");
//
//       this.nextComplete = false;
//   this.itemsList = [];
//   CollectionAndClasses.collection = [0];
//   this.highlightSelectedCollection(col.collection.id);
//
//   this.selectedCollection = col;
//
//   let subcollections = [];
//   for ( let sub of this.selectedCollection.subCollection){
//     subcollections.push(sub.id);
//   }
//
//   if(subcollections.length < 1){
//     subcollections = [0];
//     CollectionAndClasses.collection = [col.collection.id];
//   }
//
//   this.classesList = this.selectedCollection.collection.classes;
//   if(col.subCollection.length > 0){
//
//     this.subCollection = col.subCollection;
//   }else{
//     this.subCollection = [];
//   }
//
//     CollectionAndClasses.subCollection = subcollections;
//     CollectionAndClasses.categories=[0];
//     CollectionAndClasses.tags=[0];
//
//
//     this.collectionAndClasses = CollectionAndClasses;
//     this.getProductsResolver(0,false);
//
//
//
//  }
//
//  setTimeout(() => {
//                 this.content.resize();
//             }, 80);
//
// }
//
//
//
//
// subCollectionTap(sub,col){
//
//   this.selectedAttributes = [];
//   this.collectionAndClasses.attributeFilter = [];
//   this.highlightSelected(0);
//     this.nextComplete = false;
//     // this.highlightSelectedSubCollection(sub,col);
//
//    // this.getProductsOffline(0,false);
//     this.selectedSubCol = sub;
//     this.classesList = sub.classes;
//     this.selectedClass = null;
//
//     CollectionAndClasses.collection = [0];
//     CollectionAndClasses.subCollection=[sub.id];
//     CollectionAndClasses.categories=[0];
//     CollectionAndClasses.tags=[0];
//
//     this.itemsList = [];
//     this.collectionAndClasses = CollectionAndClasses;
//     this.getProductsResolver(0,false);
//
//
//     setTimeout(() => {
//             this.content.resize();
//         }, 80);
//
// }
//
// goBackToAllSubCol(){
//
//   this.gVLogger.log("Collection Back");
//   this.selectedSubCol = null;
//   this.selectedClass = null;
//
//   CollectionAndClasses.subCollection=[0];
//   this.classesList = [];
//   let subcollections = [];
//   for ( let sub of this.selectedCollection.subCollection){
//     subcollections.push(sub.id);
//   }
//
//   if(subcollections.length < 1){
//     subcollections = [0];
//     CollectionAndClasses.collection = [this.selectedCollection.collection.id];
//   }
//   CollectionAndClasses.subCollection = subcollections;
//   this.collectionAndClasses = CollectionAndClasses;
//   this.selectedAttributes = [];
//   this.collectionAndClasses.attributeFilter = [];
//   this.getProductsResolver(0,false);
//   setTimeout(() => {
//       this.content.resize();
//     }, 80);
// }
//
// goBackToSubCollections(){
//
//   this.selectedClass = null;
//   CollectionAndClasses.categories=[0];
//   this.gVLogger.log("Classes Back");
//   this.collectionAndClasses = CollectionAndClasses;
//
//     this.itemsList = [];
//     this.collectionAndClasses = CollectionAndClasses;
//     this.getProductsResolver(0,false);
//   setTimeout(() => {
//       this.content.resize();
//     }, 80);
// }
//
//
// getCollectionMenu(){
//
//   this.allClasses = JSON.parse(localStorage.getItem('allClasses-'+this.cartManager.getADPCustomerUUID()));
//   this.collection = JSON.parse(localStorage.getItem('collection-'+this.cartManager.getADPCustomerUUID()));
//   // this.classesList = this.allClasses;
//   this.classesList = [];
//
//
//          setTimeout(() => {
//             this.content.resize();
//         }, 80);
//
// }
//
//
// getBreadCrumbs(collectionAndClasses){
//   return "";
// }
//
//
// toggleCollectionMenu(){
//
//    this.showCollections = !this.showCollections;
//    setTimeout(() => {
//       this.content.resize();
//   }, 50);
//
// }
//
//
//
// goBackToCollections(){
//   CollectionAndClasses.subCollection=[0];
//   this.gVLogger.log("Subcollection Back");
//   this.collectionAndClasses = CollectionAndClasses;
//   this.selectedAttributes = [];
//   CollectionAndClasses.attributeFilter = [];
//
//   this.highlightSelectedSubCollection({id:0},this.selectedCollection);
//   this.toggleCollectionSubCollection();
//   this.highlightSelected(0);
//   this.allProducts(0);
// }
//
//
// toggleCollectionSubCollection(){
//   this.showSubCollections = !this.showSubCollections;
// }
//
//
// gotoBookmarksPage(){
//   this.fab.close();
//   this.nav.push(BookmarksPage);
// }
//
//
//
// toggleBookmark(){
//   this.showBookmark = !this.showBookmark;
// }
//
//
// scrollToTop(){
//   setTimeout(()=>{
//     this.content.scrollToTop();
//   },200);
// }
//
//
// bookmarkProduct(item){
//
//   this.api.get("customers/likeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
//   .map(res => res.json())
//   .subscribe(result=>{
//
//     if(result.status == "401"){ // check for session out
//         this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
//
//         this.nav.setRoot(LoginPage);
//       }else if(result.status == 200){
//           if(!item.isWishlisted){
//             item.isWishlisted = 0;
//           }
//          item.isWishlisted = 1;
//         this.gVLogger.log("success");
//       }
//
//   },err=>{
//     this.gVLogger.log(err);
//   });
// }
//
// unBookmarkProduct(item){
//
//   this.api.get("customers/dislikeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
//   .map(res => res.json())
//   .subscribe(result=>{
//
//     if(result.status == "401"){ // check for session out
//         this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
//
//         this.nav.setRoot(LoginPage);
//       }else if(result.status == 200){
//         if(!item.isWishlisted){
//           item.isWishlisted = 0;
//         }
//          item.isWishlisted = 0;
//         this.gVLogger.log("success");
//       }
//
//   },err=>{
//     this.gVLogger.log(err);
//   });
//
// }
//
//
// makeImageURL(dimensions,item){
//   if(item.productImagesDTO[0].name === "dummy" || item.productImagesDTO[0].name === "dummy"){
//     if(this.constants.isWebstore){
//       return this.cartManager.makeNANImageURLFromImage(dimensions);
//     }
//     else{
//       return "./assets/img/dummy-"+dimensions+".png";
//     }
//   }else{
//     this.gVLogger.log("UUUUUUUURRRRRrl " + this.cartManager.makeImageURL(dimensions,item));
//     return this.cartManager.makeImageURL(dimensions,item);
//   }
// }
//
// getDateString(date){
//   return new Date(date).toDateString();
// }
//
// checkValidDate(date)
// {
//
//   if(moment(date, "DD-MM-YYYY").isValid()){
//     return true;
//   }
//   else{
//     return false;
//   }
// }
//
//
//
// openWebstoreSettings(){
//
//   var usr = this.cartManager.getSalesPerson();
//   var cst = this.cartManager.getSelectedCustomer();
//
//   this.gVLogger.log("User Objects"+usr);
//
//   let modal = this.modalCtrl.create(WebstoreUserSelfEditPage,{ customer: cst, user:usr ,button:"UPDATE",canEnable:false });
//       modal.onDidDismiss(data => {
//         if(data!=null){
//           this.cartManager.setSalesPerson(data.customer);
//           this.gVLogger.log("cust ... "+this.cartManager.getSelectedCustomer());
//         }
//       });
//       modal.present();
// }
//
//
// searchThroughItems(ev: any){
//   let val = ev.target.value;
// this.itemsList = [];
// if(ev.target.value!=""){
//
//
// this.searchQuery = val
// this.pageNo = 0;
// this.getProductsResolver(0,false);
// this.buttonsStatus = true;
// this.disablePreviousButton();
// if(this.pageNo <= 2){
//   this.previousButtonStatus = false;
// }
//
// }else{
//   this.itemsList = [];
//   this.searchQuery = '';
//   this.getProductsResolver(0,false);
//   this.disablePreviousButton();
//   if(this.pageNo <= 2){
//     this.previousButtonStatus = false;
//   }
// }
//
// }
//
// onCancel(ev) {
//   this.searchQuery = '';
//   this.itemsList = [];
//
//   ev.target.value = '';
//   this.getProductsResolver(0,false);
// }
//
//
//
//
// applyFilter(attribute){
//   this.gVLogger.log(attribute);
//   attribute.hide = true;
//   this.selectedAttributes.push(attribute.selected);
//   this.collectionAndClasses.attributeFilter.push(attribute.selected);
//   this.getProductsResolver(0,false);
// }
//
// deleteSelectedAttribute(selected){
//   this.selectedAttributes = this.selectedAttributes.filter((o)=> {return o !== selected});
//   this.collectionAndClasses.attributeFilter = this.collectionAndClasses.attributeFilter.filter((o)=> {return o !== selected});
//   this.getProductsResolver(0,false);
// }
//
//
// getValueFromAttMap(key){
//   return this.cartManager.getAttributeValue(key);
// }
//
//
//
// getAttributeMenuShowCount(){
//   let count = 0;
//   for(let a of this.attributeMenu){
//     if(a.showStatus === 1){
//       count++;
//     }
//   }
//   return count;
// }
//
// validMinOrder(val){
//   if(val !== null)
//   {
//     return val < 0? 0:val;
//
//   }
//   else
//   {
//     return "No Data"
//   }
// }
//
// disablePreviousButton(){
//   this.gVLogger.log("previous called" + this.pageNo);
//   if(this.pageNo <= 0 ){
//     this.previousButtonStatus = false;//UD did it true because
//   }
//   else{
//     this.previousButtonStatus = true;
//   }
// }
//
// }

import {Component,ViewChild , ElementRef ,Renderer, ɵConsole} from '@angular/core';
import {NavController,Content, Events, ToastController,ModalController,PopoverController,FabContainer} from 'ionic-angular';
import { Headers , RequestOptions, Http } from '@angular/http';
import  {LoginPage} from '../login/login';
import { MsgManager } from '../../providers/msg-manager';
import {Api} from "../../providers/api";

import {ItemPage} from "../item-details/item-details";
import {CartPage} from "../cart/cart";
import {SearchPage} from "../search/search";
import {SearchCustomersPage} from "../search-customers/search-customers";
import {CustomerWishListPage} from "../customer-wish-list/customer-wish-list";


import {ApiOffline} from "../../providers/api-offline";
import {CartManager} from "../../providers/cart-manager";
import {CART, loginUserInfo, Customer} from "../../providers/data";

import { IMAGES_BASE_URL } from "../../providers/config";
import { CATEGORIESnTAGS } from "../../providers/data";
import {Constants,CollectionAndClasses,ApplicationVariables, LicenseName} from '../../providers/config';
import { MyOrderPage } from '../my-order/my-order';
import { BookmarksPage } from '../bookmarks/bookmarks';
import {ItemsModalPage} from '../items-modal/items-modal';
import 'rxjs/add/operator/map';

import { Storage } from '@ionic/storage';
import { SpinnerDialog } from 'ionic-native';

import { WebstoreUserSelfEditPage } from '../webstore-user-self-edit/webstore-user-self-edit';

import {GVLogger} from '../../services/gv-logger';
import * as moment from 'moment';
import { TokenManager } from '../../providers/token-manager';
// import moment = require('moment');





@Component({
  selector: 'page-items',
  templateUrl: 'items.html'
})
export class ItemsPage {
  showInfiScroll = false;
  public constants = Constants;
  public collectionAndClasses = CollectionAndClasses;

  imageNotFoundObject:any;

  showSubCollections = false;
  showBookmark = false;
  allSelected = false;
  showCollections = false;

  allClasses:any;


  attributeMenu:any = [];
  selectedAttributes = [];

  isLicenseName = false;
  showClasses = false;
  selectedSubCol = null;
  selectedClass = null;

  classesList:any = [];

  selectedCollection:any;

  isWebstore = 0;
  singleValue4 = 0;

  rightMarginOFbookMark = "{margin-top: -8px; font-size: 45px; position: absolute;top: 0;right: 310px;}";
  breadCrumbs = "Browse Products for ";

  @ViewChild(Content) content: Content;

  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
  tagsSelected: any;

  public itemsList = [];
  public allDataLoaded = false;
  public customerName = "";
  tagsStatus:boolean = false;
  scrollLock:boolean = false;
  pageNo = 0;
  buttonsStatus = true;
  previousButtonStatus = true;
  nextButtonStatus = true;
  previousComplete = false;
  nextComplete = false;

  showNegative = false;

  scrollEventCount:number = 0 ;

  infiniteScrollGlobal:any;

  public categories = [];

  displayInventoryButton = loginUserInfo.showInventoryButtonFlag

  public collection = [];
  public subCollection = [];

  public itemCount = 0;

  public currentIndex;
  public arrayItemsCount = 0;

  // category or tag/s info
  public category: any = [];
  public tags: any = []; // to take care of tags, we need to define the related tags class etc...

  // view type
  public viewType;

  // sort by
  public sortBy = 'Best Match';

  allCatChip:boolean = false;

  cacheImages = false;
  cacheImagesTag = "cacheImages";
  isOffline =false;

  attributesPropertiesMap:any = new Map();

  searchQuery = "";

  adpCustomerInfo:any ={};

  public cart : any;

  restrictedToViewOrder = loginUserInfo.restrictedToViewOrder;
  selectedCurrency = ""

  constructor(public nav: NavController,
              public api:Api, private cartManager:CartManager,
              public events:Events,
              public elementRef:ElementRef ,
              public renderer:Renderer,
              private storage:Storage,
              private toastCtrl:ToastController,
              private gVLogger:GVLogger,
              private msgManager:MsgManager,
              private modalCtrl:ModalController,
              private popOver:PopoverController,
              private fab:FabContainer,
              private apiOffline:ApiOffline,
              private tokenManager:TokenManager,
              private http:Http,

  ) {
    this.cart = CART;
    this.disablePreviousButton();
    this.viewType = 'grid';

    this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
    this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    if(loginUserInfo.multiCurrencyFlag === 1 && Customer.paymentCurrency !== undefined && Customer.paymentCurrency !== "")
      this.selectedCurrency = Customer.paymentCurrency;
    else
      this.selectedCurrency = this.adpCustomerInfo.selectedCurrencySymbol
    this.isOffline = ApplicationVariables.isOffline;
    // alert("offline check : " + ApplicationVariables.isOffline);



    CollectionAndClasses.collection = [0];
    CollectionAndClasses.subCollection=[0];
    CollectionAndClasses.categories=[0];
    CollectionAndClasses.tags=[0];
    CollectionAndClasses.attributeFilter=[];

    // this.gVLogger.log("constructor");
    if(Constants.isWebstore){
      this.isWebstore = 1
    }

    this.storage.get(this.cacheImagesTag).then((cache)=>{
      this.cacheImages = cache;
    });

    this.storage.get("defaultLayout").then((defaultLayout)=>{
      if(defaultLayout === undefined || defaultLayout === null)
        this.viewType = 'grid';
      else
        this.viewType = defaultLayout;
    });

    this.storage.get("negativeInventory").then((negativeInventory)=>{
      this.showNegative = negativeInventory;
    });

    this.events.subscribe('refreshItems', () => {
      this.gVLogger.log("refresh items event called")

      this.getProductsResolver(0,false); // isPulltoRefresh = false
    });

    this.gVLogger.log("called constructor: Items");

    this.customerName = this.cartManager.getCustomerName();

    this.getCategoriesResolver();


    this.api.get("category/all").map(res => res.json())
      .subscribe(data =>{

        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }else{
          for(let cat of data.data){
            cat.isActive = false;
            this.categories.push(cat);
          }
          //this.highlightSelected();

        }
      });

    this.api.get("tags/all").map(res => res.json())
      .subscribe(data =>{
        this.gVLogger.log('-------item.ts called-----');
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }else{
          this.tags = data.data;
          if(data.data.length <= 0){
            this.tagsStatus = false;
          }else{
            this.tagsStatus = true;
          }
          this.tagsSelected = CATEGORIESnTAGS.tags;
          //this.gVLogger.log(this.categories);
        }
      });

    this.events.subscribe('categoriesUpdated',()=>{
      this.collection = JSON.parse(localStorage.getItem("collection-"+this.cartManager.getADPCustomerUUID()));
      this.allClasses = JSON.parse(localStorage.getItem("allClasses-"+this.cartManager.getADPCustomerUUID()));
    });

    // this.getProducts(0,false); // isPulltoRefresh = false

  }



  getCategoriesResolver(){

    if(ApplicationVariables.isOffline){
      this.getOfflineCategories();
    }else{
      this.getCollectionMenu();
    }
  }

  getOfflineCategories(){


    this.apiOffline.getCategories()
      .then(result => {
        // alert("Categories offline" + JSON.stringify(result));
        var json = JSON.parse(result.rows.item(0).json);

        this.allClasses = json.data.classes;
        //this.classesList = this.allClasses;

        for(let col of json.data.collectionsDTO){
          col.isActive = false;
          this.collection.push(col);
        }
        if(this.collection.length > 0){
          this.showCollections = true;
        }else{
          this.showCollections = false;
        }

        setTimeout(() => {
          this.content.resize();
        }, 80);
      });
  }



  ionViewWillLeave() {

    this.events.unsubscribe('Items:Refreshed',null);
  }

  ionViewDidLoad(){

    this.gVLogger.log("Items page: view did load");
    // this.highlightSelected();

    this.getProductsResolver(0,false);

  }

  // switch to list view
  viewList() {
    this.viewType = 'list';
  }

  // swith to grid view
  viewGrid() {
    this.viewType = 'grid';
  }

  // get discount percent
  discountPercent(originPrice, salePrice) {
    return Math.round((salePrice - originPrice) * 100 / originPrice)
  }


  // view a item
  viewItem(item) {

    this.api.get("product/" + item.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status === "200"){
        item.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, {item: item})
  }

  // go to search page
  goToSearch() {
    this.nav.push(SearchPage);
  }

  // view cart
  goToCart() {
    this.nav.push(CartPage);
  }
  goToSearchCustomers(){
    this.nav.push(SearchCustomersPage);
  }

  goToCustomerWishList(){
    this.nav.push(CustomerWishListPage);
  }


  doInfinite(infiniteScroll){

    let cartItems = this.cartManager.getItems();
    let adpCustomer = this.cartManager.getAdpCustomerInfo();
    let body = this.collectionAndClasses;
    body.detachProductSearchFromFilter = adpCustomer.detachProductSearchFromFilter;
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });
    this.itemCount = this.itemsList.length;
    this.api.post("/products/searchProductsByCollectionsClassesAndTags/"+this.itemCount+"/"+this.cartManager.getCustomerID()+"?isWebStore="+this.isWebstore,JSON.stringify(body),options)
      .map(res=>res.json())
      .subscribe(result=>{

        // this.scrollToTop();
        this.gVLogger.log("HTTP Response Data Recived");
        if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }
        else
        {
          for(let item of result.data.productsDTOs){
            this.gVLogger.log("all items from the serve" +  item);


            //for ( let item of result.data.productsDTOs){
            item.attributesList = [];
            if(item.attributeSearch.indexOf('>') !== -1){
              let tempAttributesList = item.attributeSearch.split('>');
              for(let attribute of tempAttributesList){
                if(attribute!== "")
                  item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
              }
              //}
              item.attributesList.sort(function(a,b){return a.orderId-b.orderId});


              if(LicenseName.indexOf(this.cartManager.getAdpCustomerInfo().licenseName) !== -1){
                this.isLicenseName = true;
                this.rightMarginOFbookMark = "{margin-top: -8px; font-size: 45px; position: absolute;top: 0;right: 410px;}";
                console.log("erererererererererrer" + this.displayInventoryButton);
                if(this.displayInventoryButton === 1){
                  item.displayStockLocations = false;
                  item.stockLocations = false;
                }else {
                  item.displayStockLocations = true;
                  let body = {"part" : item.barCode}
                  this.api.post("proxy/part",body)
                    .map(res=>res.json())
                    .subscribe((result)=>{
                        item.stockLocations = result.data;
                      },
                      (err)=>{
                        this.gVLogger.log(err);
                      }
                    );
                }

              }
              else{
                item.stockLocations = false;
              }

            }


            setTimeout(() => {
              // alert("after waiting....");
              for(let at of this.attributeMenu){
                at.atValue = this.cartManager.getAttributeValue(at.attribute);
                at.compiledAttributes = []
                for(let atval of at.values){
                  let id = atval;
                  let val:any = {};
                  val.id = id
                  val.text = this.cartManager.getAttributeValue(at.attribute+":"+id);
                  this.gVLogger.log(val);
                  at.compiledAttributes.push(val)
                }
              }

            }, 3000);
            item.productImagesDTO = JSON.parse(JSON.stringify(item.productImagesDTO.sort(function(a, b){return a.id - b.id})));

            for(let cItem of cartItems){
              if(item.id== cItem.id){
                item = cItem;

              }
            }

            this.itemsList.push(item);

          }
          infiniteScroll.complete();
          // this.itemsList = result.data.productsDTOs;
          // resolve(this.populateproducts(result,isPulltoRefresh));
        }

      }, error =>{
        this.gVLogger.log(error);
        this.presentToast("Server Down",3000,"bottom");
      });
  }

  loadMore(){ // Next button

    this.gVLogger.log("loadMore called");
    if(!this.nextComplete){
      SpinnerDialog.show("Loading...");
      this.buttonsStatus = false;
      this.nextButtonStatus = false;
      this.gVLogger.log("New Scroll event.");
      let count = this.currentIndex + this.arrayItemsCount;
      this.gVLogger.log("iiiiinnnnnndexxxx" + count);
      var completed = this.getProductsResolver(count,false).then(()=>{ // isPulltoRefresh = false
        SpinnerDialog.hide();
        this.buttonsStatus = true;
        //  this.nextButtonStatus = true;
        this.gVLogger.log("loadMore");
      });
    }else{
      this.nextButtonStatus = false;
      this.presentToast("No more products to load.", 2000,"bottom");
    }
    this.disablePreviousButton();
  }

  doRefresh(refresher) { // pullToRefresh
    this.buttonsStatus = false;
    let startPoint = this.currentIndex - this.arrayItemsCount ;
    if(this.nextComplete){
      startPoint -= this.arrayItemsCount;
      this.nextComplete = false;
    }
    if(startPoint >=0){
      this.getProductsResolver(startPoint,true).then(()=>{ // isPulltoRefresh = false
        refresher.complete();
        this.buttonsStatus = true;
        this.gVLogger.log("Pull to refressh completed");
      });
    }else{
      refresher.complete();
      this.buttonsStatus = true;
    }
    this.disablePreviousButton();
  }


  loadPrvious() { // load Previous
    if(!this.previousComplete){
      SpinnerDialog.show("Loading...");
      this.buttonsStatus = false;
      let startPoint = this.currentIndex - this.arrayItemsCount ;
      if(this.nextComplete){
        startPoint -= this.arrayItemsCount;
        this.nextComplete = false;
      }
      if(startPoint >=0){
        this.getProductsResolver(startPoint,true).then(()=>{ // isPulltoRefresh = false
          SpinnerDialog.hide();
          this.buttonsStatus = true;
        });
      }else{
        this.buttonsStatus = true;
        this.presentToast("No more products to load",2000,"bottom");
      }
    }else{
      this.presentToast("No more products to load",2000,"bottom");
    }

    this.disablePreviousButton();
    if(this.pageNo <= 2){
      this.previousButtonStatus = false;
    }
  }

  arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
      for(var j=i+1; j<a.length; ++j) {
        if(a[i].id === a[j].id)
          a.splice(j--, 1);
      }
    }

    return a;
  }


  addProductToCart(item){
    this.cartManager.addProductToCart(item);
  }

  removeProductFromCart(product){
    this.cartManager.removeOneNew(product);
  }

  updateProductInCart(product){

    if(String(product.quantity) !=""){
      if(String(product.quantity).match(/^\d+$/)){
        this.cartManager.updateCartNew(product);
      }else{
        if (Number(product.minOrder) != 0) {
          product.quantity = Number(product.minOrder);
        } else {
          product.quantity = 1;
        }
        this.cartManager.updateCartNew(product);
      }
    }else{

      product.quantity = Number(product.minOrder);
      this.cartManager.updateCartNew(product);
    }

  }

  allProducts(id){
    this.nextComplete = false;

    // this.classesList = this.allClasses;
    this.classesList = [];

    this.highlightSelectedCollection(0);

    // this.content.scrollToTop(0);
    CollectionAndClasses.collection = [0];
    CollectionAndClasses.subCollection=[0];
    CollectionAndClasses.categories=[id];

    this.itemsList = [];
    this.collectionAndClasses = CollectionAndClasses;
    this.getProductsResolver(0,false);
    this.highlightSelected(0);

    setTimeout(() => {
      this.content.resize();
    }, 80);

  }

  classesSelect(selectedClass){
    // this.highlightSelected(selectedClass.id);
    this.nextComplete = false;
    this.selectedClass = selectedClass;

    // this.content.scrollToTop(0);
    // CollectionAndClasses.collection = [0];
    //CollectionAndClasses.subCollection=[0];
    CollectionAndClasses.categories=[selectedClass.id];

    this.itemsList = [];
    this.collectionAndClasses = CollectionAndClasses;
    this.getProductsResolver(0,false);
  }


  getProductsResolver(itemCount,isPulltoRefresh){

    this.gVLogger.log("In Product resolver item COUNT : " + itemCount + " ISPULLTO REFRESH " + isPulltoRefresh);

    this.currentIndex = itemCount;
    return new Promise((resolve)=>{

      if(itemCount <= 0 && !isPulltoRefresh){
        this.gVLogger.log("If called in product resolver");
        itemCount = 0;
        this.pageNo = 0;
      }

      if(ApplicationVariables.isOffline){
        resolve(this.getProductsOffline(itemCount,isPulltoRefresh));
      }else{
        resolve(this.getProducts(itemCount,isPulltoRefresh));
      }
    });
  }

  getProductsOffline(itemCount,isPulltoRefresh){
    // alert("getProductsOffline called");

    return new Promise((resolve)=>{



      //  alert("Enter in get products offline" + itemCount);

      this.apiOffline.getProductsOffline(CollectionAndClasses,itemCount,this.searchQuery).then(result => {
        // alert("result after getting offline products " + result);
        // alert("result after getting offline products stringify" + JSON.stringify(result));


        if(result.rows.length < 24){
          this.nextButtonStatus = false;
        }
        else{
          this.nextButtonStatus = true;
        }

        let response :any = {
          status: 200,
          message: "Offline Mode",
          data: {productsDTOs:[]}
        }





        //UD

        this.apiOffline.getAttributes().then(res => {
          let attributes = JSON.parse(res);
        })
        let productsLazy:any = [];
        // alert("length of the offline products" + result.rows.length);
        for(var i=0; i<result.rows.length; i++)
        {
          var json = JSON.parse(result.rows.item(i).json);
          // alert("Json of products" + JSON.stringify(json));
          productsLazy.push(json);
        }

        response.data.productsDTOs = productsLazy;
        // alert(JSON.stringify(response));
        this.populateproducts(response, isPulltoRefresh);
      })

    });

  }


  getProducts(itemCount,isPulltoRefresh){

    this.showInfiScroll = false;
    return new Promise(resolve => {

      let adpCustomer = this.cartManager.getAdpCustomerInfo();
      let body :any= this.collectionAndClasses;
      body.searchQuery = this.searchQuery;
      body.detachProductSearchFromFilter = adpCustomer.detachProductSearchFromFilter;
      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

      this.currentIndex = itemCount;
      this.gVLogger.log("HTTP Request Before Send");


      setTimeout(() => {

        this.api.post("/products/searchProductsByCollectionsClassesAndTags/"+itemCount+"/"+this.cartManager.getCustomerID()+"?isWebStore="+this.isWebstore,JSON.stringify(body),options)
          // this.api.post("/products/searchProductsByCollectionsClassesAndTag/"+itemCount+"/"+this.cartManager.getCustomerID()+"?isWebStore="+this.isWebstore,JSON.stringify(body),options)
          .map(res=>res.json())
          .subscribe(result=>{
            if(result.data.productsDTOs.length < 12){
              this.nextButtonStatus = false;
            }
            else{
              this.nextButtonStatus = true;
            }
            this.showInfiScroll = true;
            if(this.attributesPropertiesMap.size === 0){
              this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
            }

            for ( let item of result.data.productsDTOs){

              item.attributesList = [];

              // if(item.attributeSearch.indexOf('>') !== -1){
              if(item.attributeSearch !== -1 && item.attributeSearch != undefined){
                let tempAttributesList = item.attributeSearch.split('>');
                for(let attribute of tempAttributesList){
                  if(attribute !== "")
                    item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
                }
              }


              item.attributesList.sort(function(a,b){return a.orderId-b.orderId})
              // result.data.attributeMenu = item.attributesList;
            }

            // this.scrollToTop();
            if(result.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }else{
              resolve(this.populateproducts(result,isPulltoRefresh));
            }

          }, error =>{
            this.gVLogger.log(error);
            this.presentToast("Server Down",3000,"bottom");
          });
      },0);
    });
  }


  populateproducts(result,isPulltoRefresh){

    return new Promise((resolve)=>{

      //UD
      if(!this.isOffline){
        this.attributeMenu = result.data.attributeMenu;///////UD do this only for testing purpose


        setTimeout(() => {

          for(let at of this.attributeMenu){
            at.atValue = this.cartManager.getAttributeValue(at.attribute);
            at.compiledAttributes = [];
            this.gVLogger.log("at.atvalue"+ at.atValue);

            at.props = this.attributesPropertiesMap.get(at.attribute);
            at.showStatus = at.props.attSearchStatus;
            at.activeStatus = at.props.attActiveStatus;
            for(let atval of at.values){
              let id = atval;
              let val:any = {};
              val.id = id
              val.text = this.cartManager.getAttributeValue(at.attribute+":"+id);
              this.gVLogger.log(val);
              at.compiledAttributes.push(val)
            }

            // at.compiledAttributes.sort(function(a){return a.text});
            at.compiledAttributes.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));

          }
          this.attributeMenu.sort(function(a, b){return a.props.attSequence-b.props.attSequence})

          this.gVLogger.log("HERE"+this.attributeMenu);
          let attributeMenu1 = [];

          for(let attributes of this.attributeMenu){
            if(attributes.activeStatus == 1){
              attributeMenu1.push( attributes);
            }
          }

          this.attributeMenu = attributeMenu1;
          this.gVLogger.log("Without"+ this.attributeMenu)

        }, 0);

        for(let selections of this.selectedAttributes){
          this.attributeMenu = this.attributeMenu.filter((o)=> {
            return o.attribute !== selections.split(":")[0];
          })
        }

      }



      //UD

      let cartItems = this.cartManager.getItems();

      let oldItems = this.itemsList;

      let pullTemp = [];

      if(!(typeof result === 'undefined') && result){
        if (result.data.productsDTOs && result.data.productsDTOs.constructor === Array) {

        } else {
          result.data.productsDTOs = [];
        }
      }else{
        result = { data: {}};
        result.data.productsDTOs = [];
      }


      if(result.data.productsDTOs.length >= this.arrayItemsCount || this.arrayItemsCount == 0){
        this.arrayItemsCount = result.data.productsDTOs.length;
      }

      if(result.data.productsDTOs.length > 0){
        this.itemsList = [];

        if(isPulltoRefresh){
          this.pageNo -= 1;
          this.nextComplete = false;
        }else{
          this.pageNo += 1;
          this.previousComplete = false;
        }

      }else{

        if(isPulltoRefresh){
          this.previousButtonStatus = false; //UD
          this.previousComplete = true;
        }else{
          this.nextComplete = true;
        }

        this.presentToast("No more products to display.",3000,"bottom");

      }


      for ( let item of result.data.productsDTOs){

        if(LicenseName.indexOf(this.cartManager.getAdpCustomerInfo().licenseName) !== -1){
          this.isLicenseName = true;
          this.rightMarginOFbookMark = "{margin-top: -8px; font-size: 45px; position: absolute;top: 0;right: 410px;}";
          console.log("erererererererererrer" + this.displayInventoryButton);
          if(this.displayInventoryButton === 1){
            item.displayStockLocations = false;
            item.stockLocations = false;
          }else {
            let body = {"part" : item.barCode}
            this.api.post("proxy/part",body)
              .map(res=>res.json())
              .subscribe((result)=>{
                  item.stockLocations = result.data;
                  this.gVLogger.log("InstantRead --- "+ item);

                },
                (err)=>{
                  this.gVLogger.log(err);
                }
              );
          }


        }
        else{
          item.stockLocations = false;
        }


        this.gVLogger.log("2 - "+ item.stockLocations);

        item.productImagesDTO = JSON.parse(JSON.stringify(item.productImagesDTO.sort(function(a, b){return a.id - b.id})));
        if(!Constants.isWebstore){
          item.namecompact = item.name.length > 35 ? item.name.substring(0, 35 - 3) + "..." : item.name;
          item.namecompact = item.name.length < 20  ? item.name + " . . . . ." : item.name;
        }

        item.quantity = 0 ;

        for(let cartItem of cartItems){
          if(item.id== cartItem.id){
            item = cartItem
          }

        }
        if(result.data.productsDTOs.length > 0){

          if(isPulltoRefresh){
            this.itemsList.push(item);
            // if (item.productType === 0 ){
            //   this.gVLogger.log("iiiiiiiiiffffffffff ccccccccallllllled");
            //   this.itemsList.push(item);
            // }else if(item.productType === 1 && item.qtyONHAND > 0){
            //   this.itemsList.push(item);
            // }

          }else{
            this.itemsList.push(item);

          }
        }
      }



      // alert("Item Count: "+ this.itemsList.length);


      this.gVLogger.log("Old Itmes check ===>");
      if(result.data.productsDTOs.length > 0){
        if(oldItems.length > (this.arrayItemsCount * 1)){
          this.gVLogger.log("old items length : "+oldItems.length +": current : "+this.arrayItemsCount);
          if(isPulltoRefresh){
            // arraysize = 2
            // [1,2,3,4,5,6]
            // [1,2]

            this.itemsList = this.itemsList.slice(0,this.arrayItemsCount);

          }else{
            this.gVLogger.log("getting last items");
            this.itemsList = this.itemsList.slice(Math.max(this.itemsList.length - this.arrayItemsCount, 1));

          }

        }
      }

      if(this.content != null){
        //  this.content.scrollToTop(0).then(()=>{
        setTimeout(()=>{
          resolve(true);
        },300);
        //});
      }else{
        resolve(true);
      }

    });

  }



  tagsSelectedChange(e){

    CATEGORIESnTAGS.tags = this.tagsSelected;
    if(CATEGORIESnTAGS.tags.length == 0){
      CATEGORIESnTAGS.tags = [0];
    }
    this.getProductsResolver(0,false); // isPulltoRefresh = false

  }

  imageNotFound(e,item){
    item.productImagesDTO[0].name = "dummy";
    item.productImagesDTO[0].extension = "png";
  }

  getFallBackImage(dim){
    if(this.constants.isWebstore){
      return this.cartManager.makeNANImageURLFromImage(dim);

    }else{
      return "./assets/img/dummy-"+dim+".png";
    }
  }


  scrollTop(){

    this.nav.setRoot(ItemsPage);
  }

  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }


  highlightSelected(id){

    for(let localCat of this.classesList){
      if(id == localCat.id){
        localCat.isSelected=true;
      }else{
        localCat.isSelected=false;
      }
    }

  }


  highlightSelectedSubCollection(sub,col){

    this.highlightSelected(0);

    for(let c of this.collection){
      if(c.id == col.id){
        for(let s of c.subCollection){
          if(s.id == sub.id){
            s.isSelected = true;
          }else{
            s.isSelected = false;
          }
        }
      }
    }

  }

  highlightSelectedCollection(col){
    this.gVLogger.log("Collection Recived"+col);
    this.gVLogger.log("Collection List"+this.collection);
    this.highlightSelected(0);

    if(col == 0){
      this.allSelected = true;
      for(let c of this.collection){
        c.collection.isSelected = false;
      }
    }else{
      this.allSelected = false;
      for(let c of this.collection){
        if(c.collection.id == col){
          c.collection.isSelected = true;
        }else{
          c.collection.isSelected = false;
        }
      }

    }

  }

  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  public identify(index, item) {
    this.gVLogger.log("Item Name Is : "+item.name+" : ID : "+ item.id);
    return item.id;
  }



  gotoOrdersPage(){
    this.nav.setRoot(MyOrderPage);
  }


  presentToast(msg,duration,location) {
    this.gVLogger.log("TOAST: "+msg);
    let toast = this.toastCtrl.create({
      message: msg,
      duration: duration,
      position: location
    });
    toast.present();
  }

  logOut(){
    this.nav.setRoot(LoginPage);
  }

  showModalCollections(){
    this.gVLogger.log("clicked modal call");
    let mod = this.modalCtrl.create(ItemsModalPage);
    mod.present();
  }

  allClick(){
    CollectionAndClasses.attributeFilter = [];
    this.collectionAndClasses.selectedAttributes = [];
    this.selectedAttributes = [];
    this.selectedSubCol = null;
    this.selectedClass = null;
    this.allProducts(0);
  }


  collectionSelected(ev,col){
    // alert("this.collection called");
    this.gVLogger.log(col);

    this.searchQuery = "";
    this.selectedAttributes = [];
    this.collectionAndClasses.attributeFilter = [];
    this.selectedSubCol = null;
    this.selectedClass = null;

    if(col.subCollection.length > 0){
      this.gVLogger.log("Have children");



      this.nextComplete = false;
      this.itemsList = [];
      CollectionAndClasses.collection = [0];
      this.toggleCollectionSubCollection();
      this.selectedCollection = col;

      let subcollections = [];
      for ( let sub of this.selectedCollection.subCollection){
        subcollections.push(sub.id);
      }

      if(subcollections.length < 1){
        subcollections = [0];
        CollectionAndClasses.collection = [col.collection.id];
      }

      this.classesList = [];
      // this.classesList = this.selectedCollection.collection.classes;
      if(col.subCollection.length > 0){

        this.subCollection = col.subCollection;
      }else{
        this.subCollection = [];
      }

      CollectionAndClasses.subCollection = subcollections;
      CollectionAndClasses.categories=[0];
      CollectionAndClasses.tags=[0];


      this.collectionAndClasses = CollectionAndClasses;
      this.getProductsResolver(0,false);

      // this.getProductsOffline(0,false);

      setTimeout(() => {
        this.content.resize();
      }, 80);

    }else{
      this.toggleCollectionSubCollection();
      // this.classesList = col.classes;

      this.gVLogger.log("No children");

      this.nextComplete = false;
      this.itemsList = [];
      CollectionAndClasses.collection = [0];
      this.highlightSelectedCollection(col.collection.id);

      this.selectedCollection = col;

      let subcollections = [];
      for ( let sub of this.selectedCollection.subCollection){
        subcollections.push(sub.id);
      }

      if(subcollections.length < 1){
        subcollections = [0];
        CollectionAndClasses.collection = [col.collection.id];
      }

      this.classesList = this.selectedCollection.collection.classes;
      if(col.subCollection.length > 0){

        this.subCollection = col.subCollection;
      }else{
        this.subCollection = [];
      }

      CollectionAndClasses.subCollection = subcollections;
      CollectionAndClasses.categories=[0];
      CollectionAndClasses.tags=[0];


      this.collectionAndClasses = CollectionAndClasses;
      this.getProductsResolver(0,false);



    }

    setTimeout(() => {
      this.content.resize();
    }, 80);

  }




  subCollectionTap(sub,col){

    this.selectedAttributes = [];
    this.collectionAndClasses.attributeFilter = [];
    this.highlightSelected(0);
    this.nextComplete = false;
    // this.highlightSelectedSubCollection(sub,col);

    // this.getProductsOffline(0,false);
    this.selectedSubCol = sub;
    this.classesList = sub.classes;
    this.selectedClass = null;

    CollectionAndClasses.collection = [0];
    CollectionAndClasses.subCollection=[sub.id];
    CollectionAndClasses.categories=[0];
    CollectionAndClasses.tags=[0];

    this.itemsList = [];
    this.collectionAndClasses = CollectionAndClasses;
    this.getProductsResolver(0,false);


    setTimeout(() => {
      this.content.resize();
    }, 80);

  }

  goBackToAllSubCol(){

    this.gVLogger.log("Collection Back");
    this.selectedSubCol = null;
    this.selectedClass = null;

    CollectionAndClasses.subCollection=[0];
    this.classesList = [];
    let subcollections = [];
    for ( let sub of this.selectedCollection.subCollection){
      subcollections.push(sub.id);
    }

    if(subcollections.length < 1){
      subcollections = [0];
      CollectionAndClasses.collection = [this.selectedCollection.collection.id];
    }
    CollectionAndClasses.subCollection = subcollections;
    this.collectionAndClasses = CollectionAndClasses;
    this.selectedAttributes = [];
    this.collectionAndClasses.attributeFilter = [];
    this.getProductsResolver(0,false);
    setTimeout(() => {
      this.content.resize();
    }, 80);
  }

  goBackToSubCollections(){

    this.selectedClass = null;
    CollectionAndClasses.categories=[0];
    this.gVLogger.log("Classes Back");
    this.collectionAndClasses = CollectionAndClasses;

    this.itemsList = [];
    this.collectionAndClasses = CollectionAndClasses;
    this.getProductsResolver(0,false);
    setTimeout(() => {
      this.content.resize();
    }, 80);
  }


  getCollectionMenu(){

    this.allClasses = JSON.parse(localStorage.getItem('allClasses-'+this.cartManager.getADPCustomerUUID()));
    this.collection = JSON.parse(localStorage.getItem('collection-'+this.cartManager.getADPCustomerUUID()));
    // this.classesList = this.allClasses;
    this.classesList = [];


    setTimeout(() => {
      this.content.resize();
    }, 80);

  }


  getBreadCrumbs(collectionAndClasses){
    return "";
  }


  toggleCollectionMenu(){

    this.showCollections = !this.showCollections;
    setTimeout(() => {
      this.content.resize();
    }, 50);

  }



  goBackToCollections(){
    CollectionAndClasses.subCollection=[0];
    this.gVLogger.log("Subcollection Back");
    this.collectionAndClasses = CollectionAndClasses;
    this.selectedAttributes = [];
    CollectionAndClasses.attributeFilter = [];

    this.highlightSelectedSubCollection({id:0},this.selectedCollection);
    this.toggleCollectionSubCollection();
    this.highlightSelected(0);
    this.allProducts(0);
  }


  toggleCollectionSubCollection(){
    this.showSubCollections = !this.showSubCollections;
  }


  gotoBookmarksPage(){
    this.fab.close();
    this.nav.push(BookmarksPage);
  }



  toggleBookmark(){
    this.showBookmark = !this.showBookmark;
  }


  scrollToTop(){
    setTimeout(()=>{
      this.content.scrollToTop();
    },200);
  }


  bookmarkProduct(item){

    this.api.get("customers/likeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
      .map(res => res.json())
      .subscribe(result=>{

        if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }else if(result.status == 200){
          if(!item.isWishlisted){
            item.isWishlisted = 0;
          }
          item.isWishlisted = 1;
          this.gVLogger.log("success");
        }

      },err=>{
        this.gVLogger.log(err);
      });
  }

  unBookmarkProduct(item){

    this.api.get("customers/dislikeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
      .map(res => res.json())
      .subscribe(result=>{

        if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }else if(result.status == 200){
          if(!item.isWishlisted){
            item.isWishlisted = 0;
          }
          item.isWishlisted = 0;
          this.gVLogger.log("success");
        }

      },err=>{
        this.gVLogger.log(err);
      });

  }


  makeImageURL(dimensions,item){
    if(item.productImagesDTO[0].name === "dummy" || item.productImagesDTO[0].name === "dummy"){
      if(this.constants.isWebstore){
        return this.cartManager.makeNANImageURLFromImage(dimensions);
      }
      else{
        return "./assets/img/dummy-"+dimensions+".png";
      }
    }else{
      this.gVLogger.log("UUUUUUUURRRRRrl " + this.cartManager.makeImageURL(dimensions,item));
      return this.cartManager.makeImageURL(dimensions,item);
    }
  }

  getDateString(date){
    return new Date(date).toDateString();
  }

  checkValidDate(date)
  {

    if(moment(date, "DD-MM-YYYY").isValid()){
      return true;
    }
    else{
      return false;
    }
  }



  openWebstoreSettings(){

    var usr = this.cartManager.getSalesPerson();
    var cst = this.cartManager.getSelectedCustomer();

    this.gVLogger.log("User Objects"+usr);

    let modal = this.modalCtrl.create(WebstoreUserSelfEditPage,{ customer: cst, user:usr ,button:"UPDATE",canEnable:false });
    modal.onDidDismiss(data => {
      if(data!=null){
        this.cartManager.setSalesPerson(data.customer);
        this.gVLogger.log("cust ... "+this.cartManager.getSelectedCustomer());
      }
    });
    modal.present();
  }


  searchThroughItems(ev: any){
    let val = ev.target.value;
    this.itemsList = [];
    if(ev.target.value!=""){


      this.searchQuery = val
      this.pageNo = 0;
      this.getProductsResolver(0,false);
      this.buttonsStatus = true;
      this.disablePreviousButton();
      if(this.pageNo <= 2){
        this.previousButtonStatus = false;
      }

    }else{
      this.itemsList = [];
      this.searchQuery = '';
      this.getProductsResolver(0,false);
      this.disablePreviousButton();
      if(this.pageNo <= 2){
        this.previousButtonStatus = false;
      }
    }

  }

  onCancel(ev) {
    this.searchQuery = '';
    this.itemsList = [];

    ev.target.value = '';
    this.getProductsResolver(0,false);
  }




  applyFilter(attribute){
    this.gVLogger.log(attribute);
    attribute.hide = true;
    this.selectedAttributes.push(attribute.selected);
    this.collectionAndClasses.attributeFilter.push(attribute.selected);
    this.getProductsResolver(0,false);
  }

  deleteSelectedAttribute(selected){
    this.selectedAttributes = this.selectedAttributes.filter((o)=> {return o !== selected});
    this.collectionAndClasses.attributeFilter = this.collectionAndClasses.attributeFilter.filter((o)=> {return o !== selected});
    this.getProductsResolver(0,false);
  }


  getValueFromAttMap(key){
    return this.cartManager.getAttributeValue(key);
  }



  getAttributeMenuShowCount(){
    let count = 0;
    for(let a of this.attributeMenu){
      if(a.showStatus === 1){
        count++;
      }
    }
    return count;
  }

  validMinOrder(val){
    if(val !== null)
    {
      return val < 0? 0:val;

    }
    else
    {
      return "No Data"
    }
  }

  disablePreviousButton(){
    this.gVLogger.log("previous called" + this.pageNo);
    if(this.pageNo <= 0 ){
      this.previousButtonStatus = false;//UD did it true because
    }
    else{
      this.previousButtonStatus = true;
    }
  }

  getProxyOnCheckButton(item){
    let body = {"part" : item.barCode}
    this.api.post("proxy/part",body)
      .map(res=>res.json())
      .subscribe((result)=>{
          item.displayStockLocations = true;
          item.stockLocations = result.data;
          this.gVLogger.log("InstantRead --- "+ item);

        },
        (err)=>{
          this.gVLogger.log(err);
        }
      );
  }

}




// WEBPACK FOOTER //
// ./src/pages/items/items.ts